import React, { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CardImage } from "@/components/CardImage";
import { AlertTriangle, ImagePlus, X } from "lucide-react";
import { toast } from "sonner";

export const DISPUTE_CATEGORIES = { pacco_non_ricevuto: "Pacco non ricevuto", carta_danneggiata: "Carta danneggiata", carta_differente: "Carta differente da quella concordata", comunicazione: "Problemi di comunicazione", altro: "Altri problemi" };

export function DisputeDialog({ pid, categories = DISPUTE_CATEGORIES, onDone, triggerTestId = "open-dispute" }) {
  const [open, setOpen] = useState(false);
  const [cat, setCat] = useState("");
  const [desc, setDesc] = useState("");
  const [photos, setPhotos] = useState([]);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    try { const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } }); setPhotos((p) => [...p, data.path]); }
    catch (e) { toast.error(apiError(e)); }
  };
  const submit = async () => {
    setBusy(true);
    try { await api.post("/reputation/disputes", { proposal_id: pid, category: cat, description: desc, photos }); toast.success("Contestazione inviata alla moderazione."); setOpen(false); onDone?.(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} data-testid={triggerTestId} variant="outline" className="border-[#F59E0B]/40 bg-transparent text-[#F59E0B] hover:bg-[#F59E0B]/10"><AlertTriangle className="mr-2 h-4 w-4" />Segnala un problema</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[92vh] overflow-y-auto bg-[#141B2D] border-[#2A3655] text-[#F8FAFC]" data-testid="dispute-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">Apri una contestazione</DialogTitle>
            <DialogDescription className="text-[#94A3B8]">Descrizione e foto sono visibili solo a te, alla controparte e alla moderazione. Omniverse non offre rimborsi, assicurazioni o protezione degli acquisti: la moderazione valuta il caso e può sospendere o annullare lo scambio.</DialogDescription>
          </DialogHeader>
          <div className="grid gap-2 sm:grid-cols-2">
            {Object.entries(categories || {}).map(([k, l]) => (
              <button key={k} type="button" onClick={() => setCat(k)} data-testid={`dispute-cat-${k}`} className={`rounded-lg border px-3 py-2 text-left text-sm transition-colors ${cat === k ? "border-[#F59E0B] bg-[#F59E0B]/10 text-[#F59E0B]" : "border-[#2A3655] text-[#CBD5E1] hover:border-[#F59E0B]/50"}`}>{l}</button>
            ))}
          </div>
          <div><Label className="text-xs text-[#CBD5E1]">Descrizione *</Label><Textarea value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Cosa è successo? (almeno 10 caratteri)" data-testid="dispute-description" className="bg-[#0B1020] border-[#2A3655]" /></div>
          <div className="flex flex-wrap items-center gap-2">
            {photos.map((ph) => (
              <div key={ph} className="relative w-16"><CardImage path={ph} className="w-16" />
                <button type="button" onClick={() => setPhotos((p) => p.filter((x) => x !== ph))} className="absolute -right-1 -top-1 rounded-full bg-[#EF4444] p-0.5"><X className="h-3 w-3 text-white" /></button></div>
            ))}
            {photos.length < 6 && (
              <label className="flex h-16 w-16 cursor-pointer items-center justify-center rounded-lg border border-dashed border-[#2A3655] text-[#94A3B8] hover:border-[#F59E0B]" data-testid="dispute-photo-label">
                <ImagePlus className="h-5 w-5" /><input type="file" accept="image/*" className="hidden" data-testid="dispute-photo-input" onChange={(e) => e.target.files?.[0] && upload(e.target.files[0])} />
              </label>
            )}
          </div>
          <Button onClick={submit} disabled={busy || !cat || desc.trim().length < 10} data-testid="dispute-submit" className="bg-[#F59E0B] text-[#111] hover:bg-[#e08e0a]">Invia contestazione</Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
